import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Helpers from '@rogues/shared/mixins/helpers';
import { YIcon } from '@components/index';
import { digits } from '@nodes/helpers/number';
import Props from './props';

@Component({
    components: {
        YIcon,
    },
})

/**
 * @name ContactInfo
 */
export default class ContactInfo extends Mixins(HybridMixin, Props, Helpers) {
    /**
     * Format number
     */
    digits = digits

    /**
     * Return contact_details from settings.
     *
     * @param {string} slug
     * @param {number | string} index
     * @param {string} locale
     * @returns {string | Array}
     */
    info(slug: string, index: number | string = this.branch, locale: string = this.$i18n.locale): Array<any> {
        // eslint-disable-next-line dot-notation
        return this.getValue('content')['elements'][parseInt(index.toString(), 10) - 1][slug][locale];
    }
}
